// extracted by mini-css-extract-plugin
export default {"swipper-container":"styles_swipper-container__FpW4Z","swipper":"styles_swipper__H0JtW","circle":"styles_circle__h8eob","active":"styles_active__dZP5k"};